const ucfirst = (string) => `${string.charAt(0).toUpperCase()}${string.substring(1)}`;
export {
  ucfirst
};
//# sourceMappingURL=ucfirst.js.map
